module.exports = __webpack_public_path__ + "img/signup-carousel-first@3x.98d5cf11.png";